import * as RDS from 'ouisys-engine/dist/common-types/RemoteDataState';
import * as React from 'react';
import Loader from '../Loader/index';
// import CreditCardInput from 'react-credit-card-input';
import { Input, InputType, Select, SelectType } from 'ouisys-component-library';
import { IUserDetails, SubmitUserDetailsFailure, SubmitUserDetailsSuccess } from 'ouisys-engine/dist/reducers/creditCardFlow/CreditCardTypes';
import { tracker } from 'ouisys-engine/dist/reducers/strategy';
import { useState } from 'react';
import { injectIntl, Translate } from '../../localization/index';
import CreditCardInput from 'react-credit-card-input';
import { set } from 'ramda';
import './UserDetailsEntryStep.scss';

/*
  TODO:
  Once the page is done & live, let's clean the whole component and
  remove all those function and elements that we do not need anymore.
*/

interface UserDetailsEntryStepProps {
  rds: RDS.RemoteDataState<SubmitUserDetailsFailure, SubmitUserDetailsSuccess>;
  onEnd: (userDetails: IUserDetails) => void;
  locale: string;
  intl: any;
}

// for translations
const defaultMessages = {
  firstname: {
    id: 'firstname',
    defaultMessage: 'First Name'
  },
  lastname: {
    id: 'lastname',
    defaultMessage: 'Last Name'
  },
  email: {
    id: 'email',
    defaultMessage: 'Email'
  },
  address: {
    id: 'address',
    defaultMessage: 'Address'
  },
  postcode: {
    id: 'postcode',
    defaultMessage: 'Postcode'
  },
  city: {
    id: 'city',
    defaultMessage: 'City'
  },
  country: {
    id: 'country_code',
    defaultMessage: 'Country'
  },
  rockmanid: {
    id: 'rockman_id',
    defaultMessage: 'Rockman ID'
  },
  serviceid: {
    id: 'service_id',
    defaultMessage: 'Rockman ID'
  },
  required: {
    id: 'required',
    defaultMessage: 'is required'
  },
  cc_number: {
    id: 'cardNumber',
    defaultMessage: 'Credit Card Number'
  },
  cc_holder: {
    id: 'cardHolder',
    defaultMessage: 'Credit Card Holder Name'
  },
  expirationYear: {
    id: 'expYear',
    defaultMessage: 'Expiry Year'
  },
  expirationMonths: {
    id: 'expMonth',
    defaultMessage: 'Expiry Month'
  },
  cvv: {
    id: 'cvv',
    defaultMessage: 'CVV Code'
  },
  invalid:{
    id: 'invalid',
    defaultMessage: 'is invalid'
  },
  expDate: {
    id: 'expDate',
    defaultMessage: 'Expiry Date'
  },
  expDatePlaceholder: {
    id: 'expDatePlaceholder',
    defaultMessage: 'MM/YY'
  },
  cvcPlaceholder: {
    id: 'cvcPlaceholder',
    defaultMessage: 'CVC'
}}

const UserDetailsEntryStep = ({ rds, onEnd, locale, intl }: UserDetailsEntryStepProps) => {
  const vod = require('../../assets/imgs/vod-devices.png');
  const { visitor } = window.pac_analytics;
  const { rockmanId } = visitor;

  // email validation
  function isEmailValid(email) {
    var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email);
  }

  // postcode validation
  function isPostCodeValid(postalCode) {
    var regex = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;
    return regex.test(postalCode);
  }

  // validation
  const [validFirstname, setValidFirstname] = useState(true);
  const [validLastname, setValidLastname] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [validAddress, setValidAddress] = useState(true);
  const [validPostcode, setValidPostcode] = useState(true);
  const [validCity, setValidCity] = useState(true);
  const [validCountry, setValidCountry] = useState(true);
  const [validExpirationYear, setValidExpirationYear] = useState(true);
  const [validExpirationMonths, setValidExpirationMonths] = useState(true);
  const [validCvv, setValidCvv] = useState(true);
  const [validCcnumber, setValidCc_number] = useState(true);
  const [validCcholder, setValidCcHolder] = useState(true);

  // fields and values
  const [firstname, setFirstname] = useState('default');
  const [lastname, setLastname] = useState('default');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('default');
  const [postcode, setPostcode] = useState('default');
  const [city, setCity] = useState('default');
  const [country, setCountry] = useState('FR');
  const [cc_number, setCc_number] = useState('');
  const [cc_holder, setCc_holder] = useState('');
  const [expirationYear, setExpirationYear] = useState('');
  const [expirationMonths, setExpirationMonths] = useState('');
  const [cvv, setCvv] = useState('');

  // 1 = UserDetails, 2 = CreditCardDetails
  const [step, setStep] = React.useState(1);
  const proceedToNextStep = () => {
    if (!firstname.length) {
      // firstname
      setValidFirstname(false);
    } else if (!lastname.length) {
      // lastname
      setValidLastname(false);
    } else if (!isEmailValid(email)) {
      // email
      setValidEmail(false);
    } else if (!address) {
      // address
      setValidAddress(false);
    } else if (!postcode) {
      // postcode
      setValidPostcode(false);
    } else if (!city) {
      // city
      setValidCity(false);
    // } else if (!country) {
    //   // country
    //   setValidCountry(false);
    } else {
      tracker.advancedInPreFlow('user-details-submission-success', { email });
      setStep(2);
    }
  };

  /*
    we can simplify this into one function with one useState
    let's refactor this part once the page is live - genesis

    const [formFields, setFormFields] = useState<any>({
      firstname: {
        value: '',
        valid: false
      },
      lastname: {
        value: '',
        valid: false
      },
      ...
    });
  */

  const validateFirstname = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setFirstname(value);
    setValidFirstname(valid);
    return valid;
  };
  const validateLastname = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setLastname(value);
    setValidLastname(valid);
    return valid;
  };
  const validateEmail = (ev) => {
    ev.persist();
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    const value = ev.target.value;
    const valid = emailRegex.test(value);
    setEmail(value);
    setValidEmail(valid);
    return valid;
  };
  const validateAddress = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setAddress(value);
    setValidAddress(valid);
    return valid;
  };
  const validatePostcode = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setPostcode(value);
    setValidPostcode(valid);
    return valid;
  };
  const validateCity = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setCity(value);
    setValidCity(valid);
    return valid;
  };
  const validateCountry = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setCountry(value);
    setValidCountry(valid);
    return valid;
  };
  const validateCcnumber = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length >= 16;
    setCc_number(value);
    setValidCc_number(valid);
    return valid;
  };
  const validateCcholder = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setCc_holder(value);
    setValidCcHolder(valid);
    return valid;
  };
  const validateExpirationYear = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value < 3000;
    setExpirationYear(value);
    setValidExpirationYear(valid);
    return valid;
  };
  const validateExpirationMonths = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value < 13;
    setExpirationMonths(value);
    setValidExpirationMonths(valid);
    return valid;
  };
  const validateCvv = (ev) => {
    ev.persist();
    const value = ev.target.value;
    const valid = value.length > 0;
    setCvv(value);
    setValidCvv(valid);
    return valid;
  };

  return (
    <div className="subscriptionArea">
      <style>{`
        .cc-mod-control > label:nth-child(3)::before {
          content: "${intl.formatMessage(defaultMessages.expDate)}";
        }
        .cc-mod-control > label:nth-child(4)::before {
          content: "${intl.formatMessage(defaultMessages.cvv)}";
        }
      `}</style>
      <form
        autoComplete="on"
        onSubmit={(ev) => {
          ev.preventDefault();
          onEnd({
            first_name: firstname,
            last_name: lastname,
            email,
            address,
            postcode,
            city,
            country_code: country,
            cc_number,
            cc_holder,
            cc_exp_month: expirationMonths,
            cc_exp_year: expirationYear,
            cvv
          });
        }}
      >

        {step === 1 && (
          <section className="userDetails">
            <div className="box">
              <div className="left top">
                <h4>
                  <Translate id="userDetailsTitle" defaultMessage="Access your content in 3 easy steps" />
                </h4>
                <div className="steps">
                  <div>
                    <Translate id="udStep1" defaultMessage="Create your account" />
                  </div>
                  <div>
                    <Translate id="udStep2" defaultMessage="Verify your account with a credit card" />
                  </div>
                  <div>
                    <Translate id="udStep3" defaultMessage="Access your content" />
                  </div>
                </div>
              </div>
              <div className="right bottom">
                <h4 className="desktop">
                  <Translate id="userDetailsTitle2" defaultMessage="Create your account" />
                </h4>
                <div className="form-group hide">
                  <label className="form-label">
                    <Translate id="firstname" defaultMessage="First Name" />
                  </label>
                  <Input
                    id={defaultMessages.firstname.id}
                    value={firstname}
                    onBlur={validateFirstname}
                    onChange={validateFirstname}
                    required
                    // label="Name"
                    placeholder={intl.formatMessage(defaultMessages.firstname)}
                    className="form-control"
                    error={
                      !validFirstname &&
                      intl.formatMessage(defaultMessages.firstname) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="cc-given-name"
                  />
                </div>
                <div className="form-group hide">
                  <label className="form-label">
                    <Translate id="lastname" defaultMessage="Last Name" />
                  </label>
                  <Input
                    id={defaultMessages.lastname.id}
                    value={lastname}
                    onBlur={validateLastname}
                    onChange={validateLastname}
                    required
                    // label="Name"
                    placeholder={intl.formatMessage(defaultMessages.lastname)}
                    className="form-control"
                    error={
                      !validLastname &&
                      intl.formatMessage(defaultMessages.lastname) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="cc-family-name"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <Translate id="email" defaultMessage="Email" />
                  </label>
                  <Input
                    id={defaultMessages.email.id}
                    value={email}
                    onBlur={validateEmail}
                    onChange={validateEmail}
                    required
                    // label="Email"
                    placeholder={intl.formatMessage(defaultMessages.email)}
                    className="form-control"
                    error={
                      !validEmail &&
                      intl.formatMessage(defaultMessages.email) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Email}
                    autoComplete="email"
                  />
                </div>
                <div className="form-group hide">
                  <label className="form-label">
                    <Translate id="address" defaultMessage="Address" />
                  </label>
                  <Input
                    id={defaultMessages.address.id}
                    value={address}
                    onBlur={validateAddress}
                    onChange={validateAddress}
                    required
                    // label="Address"
                    placeholder={intl.formatMessage(defaultMessages.address)}
                    className="form-control"
                    error={
                      !validAddress &&
                      intl.formatMessage(defaultMessages.address) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="billing street-address"
                  />
                </div>
                <div className="form-group hide">
                  <label className="form-label">
                    <Translate id="postcode" defaultMessage="Postcode" />
                  </label>
                  <Input
                    id={defaultMessages.postcode.id}
                    value={postcode}
                    onBlur={validatePostcode}
                    onChange={validatePostcode}
                    required
                    // label="Postcode"
                    placeholder={intl.formatMessage(defaultMessages.postcode)}
                    className="form-control"
                    error={
                      !validPostcode &&
                      intl.formatMessage(defaultMessages.postcode) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="billing postal-code"
                  />
                </div>
                <div className="form-group hide">
                  <label className="form-label">
                    <Translate id="city" defaultMessage="City" />
                  </label>
                  <Input
                    id={defaultMessages.city.id}
                    value={city}
                    onBlur={validateCity}
                    onChange={validateCity}
                    required
                    placeholder={intl.formatMessage(defaultMessages.city)}
                    className="form-control"
                    error={
                      !validCity &&
                      intl.formatMessage(defaultMessages.city) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="billing address-level2"
                  />
                </div>
                <button type="button" disabled={!email || !validEmail} 
                 onClick={() => {
                  proceedToNextStep();
                  tracker.advancedInPreFlow("step2");}
                }
                >
                  <Translate id="continue" defaultMessage="Continue" />
                </button>
              </div>
            </div>
          </section>
        )}

        {step === 2 && (
          <section className="ccDetails">
            <div className="box cc-wrap">
              <div className="ccHeader">
                <div className="left">
                  <div className="age">18</div>
                </div>
                <div className="right">
                  <h4><Translate id="finalStep" defaultMessage="Final Step!" /></h4>
                  <p><Translate id="freeActivation" defaultMessage="Free Secure Activation" /></p>
                </div>
              </div>
              <div className="ccHeader2">
                <Translate id="verifyForFree" defaultMessage="Verify Your Account for Free" /> & <strong><Translate id="getAccess" defaultMessage="Get Access" /></strong>
              </div>
              {RDS.WhenLoading(null, () => (
                <div>
                  <Loader />
                </div>
              ))(rds)}
              {RDS.WhenFailure(null, (err: SubmitUserDetailsFailure) => {
                console.log('the err', err);
                tracker.recedeInFlow('Flow', 'payment-submission-failed');
                return (
                  
                  <div className="errorMsg">


                    <Translate id={err.errorType} />
                    <br />
                    {err.errorType == 'AlreadySubscribed' && (
                      <a target="_blank" href={err.productUrl}>
                        <Translate id="goToProductLabel" defaultMessage="Go to Product" />
                      </a>
                    )}
                  </div>
                );
              })(rds)}
              <div className="form-wrap">
                <div className='form-group cc-mod-custom'>
                  <label className="form-label">
                    <Translate id="cardNumberLabel" defaultMessage="Card Number" />
                  </label>
                  <CreditCardInput
                    fieldClassName="cc-mod-control"
                    dangerTextClassName="errorMsg"
                    cardNumberInputProps={{
                      value: cc_number,
                      onChange:(e) => {
                        setCc_number(e.target.value);
                        setValidCc_number(true);
                      },
                      onError: () => setValidCc_number(false),
                    }}
                    cardExpiryInputProps={{
                      autoComplete: "cc-exp",
                      onChange: (e) => {
                        const monthYearString = e.target.value;
                        const [month, year] = monthYearString.split('/');
                        setExpirationMonths(month.trim());
                        setExpirationYear(`20${year.trim()}`);
                        setValidExpirationYear(true);
                        setValidExpirationMonths(true);
                      },
                      onError: () => {
                        setValidExpirationYear(false);
                        setValidExpirationMonths(false);
                      },
                    }}
                    cardCVCInputProps={{
                      value: cvv,
                      autoComplete: "cc-cvv",
                      onChange: (e) => {
                        setCvv(e.target.value);
                        setValidCvv(true);
                      },
                      onError: () => setValidCvv(false),
                    }}
                    customTextLabels={{
                      invalidCardNumber: intl.formatMessage(defaultMessages.cc_number) + ' ' + intl.formatMessage(defaultMessages.invalid),
                      expiryError: {
                        invalidExpiryDate: intl.formatMessage(defaultMessages.expDate) + ' ' + intl.formatMessage(defaultMessages.invalid),
                        monthOutOfRange: intl.formatMessage(defaultMessages.expDate) + ' ' + intl.formatMessage(defaultMessages.invalid),
                        yearOutOfRange: intl.formatMessage(defaultMessages.expDate) + ' ' + intl.formatMessage(defaultMessages.invalid),
                        dateOutOfRange: intl.formatMessage(defaultMessages.expDate) + ' ' + intl.formatMessage(defaultMessages.invalid)
                      },
                      invalidCvc: intl.formatMessage(defaultMessages.cvv) + ' ' + intl.formatMessage(defaultMessages.invalid),
                      cardNumberPlaceholder: intl.formatMessage(defaultMessages.cc_number),
                      expiryPlaceholder: intl.formatMessage(defaultMessages.expDatePlaceholder),
                      cvcPlaceholder: intl.formatMessage(defaultMessages.cvv),
                      
                    }}
                  />
                </div>
                {/* <div className="form-group">
                  <label className="form-label">
                    <Translate id="cardInfoLabel" defaultMessage="Card Info" />
                  </label>
                  <Input
                    id={defaultMessages.cc_number.id}
                    value={cc_number}
                    onBlur={validateCcnumber}
                    onChange={validateCcnumber}
                    required
                    // label="Postcode"
                    placeholder={intl.formatMessage(defaultMessages.cc_number)}
                    className="form-control"
                    error={
                      !validCcnumber &&
                      intl.formatMessage(defaultMessages.cc_number) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Number}
                    autoComplete="cc-number"
                  />
                </div> */}

                {/* <div className="form-group">
                  <label className="form-label">
                    <Translate id="expMonthLabel" defaultMessage="Expiry Month" />
                  </label>
                  <select
                    id={defaultMessages.expirationMonths.id}
                    value={expirationMonths}
                    onBlur={validateExpirationMonths}
                    onChange={validateExpirationMonths}
                    required
                    className="form-control"
                    autoComplete="on"
                  >
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month, idx) => (
                      <option key={idx} value={month.toString().padStart(2, '0')}>
                        {month.toString().padStart(2, '0')}
                      </option>
                    ))}
                  </select>
                  {!validExpirationMonths && (
                    <div className="error-message">
                      {intl.formatMessage(defaultMessages.expirationMonths)}{' '}
                      {intl.formatMessage(defaultMessages.required)}
                    </div>
                  )}
                </div> */}
                {/* <div className="form-group">
                  <label className="form-label">
                    <Translate id="expYearLabel" defaultMessage="Expiry Year" />
                  </label>
                  <select
                    id={defaultMessages.expirationYear.id}
                    value={expirationYear}
                    onBlur={validateExpirationYear}
                    onChange={validateExpirationYear}
                    required
                    className="form-control"
                    autoComplete="on"
                  >
                    {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i).map((year, idx) => (
                      <option key={idx} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  {!validExpirationYear && (
                    <div className="error-message">
                      {intl.formatMessage(defaultMessages.expirationYear)}{' '}
                      {intl.formatMessage(defaultMessages.required)}
                    </div>
                  )}
                </div> */}
                {/* <div className="form-group">
                  <label className="form-label">CVV</label>
                  <Input
                    id={defaultMessages.cvv.id}
                    value={cvv}
                    onBlur={validateCvv}
                    onChange={validateCvv}
                    required
                    // label="Postcode"
                    placeholder={intl.formatMessage(defaultMessages.cvv)}
                    className="form-control"
                    error={
                      !validCvv &&
                      intl.formatMessage(defaultMessages.cvv) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Number}
                    autoComplete="cc-cvv"
                  />
                </div> */}

                <div className="form-group">
                  <label className="form-label">
                    <Translate id="cardHolderLabel" defaultMessage="Card Holder" />
                  </label>
                  <Input
                    id={defaultMessages.cc_holder.id}
                    value={cc_holder}
                    onBlur={validateCcholder}
                    onChange={validateCcholder}
                    required
                    // label="Postcode"
                    placeholder={intl.formatMessage(defaultMessages.cc_holder)}
                    className="form-control"
                    error={
                      !validCcholder &&
                      intl.formatMessage(defaultMessages.cc_holder) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={InputType.Text}
                    autoComplete="cc-name"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <Translate id="country" defaultMessage="Country" />
                  </label>
                  <Select
                    id={defaultMessages.country.id}
                    value={country}
                    onBlur={validateCountry}
                    onChange={validateCountry}
                    required
                    // firstOptionText="Select Country"
                    // label="Country"
                    placeholder={intl.formatMessage(defaultMessages.country)}
                    className="form-control"
                    error={
                      !validCountry &&
                      intl.formatMessage(defaultMessages.country) + ' ' + intl.formatMessage(defaultMessages.required)
                    }
                    type={SelectType.Country}
                  />
                </div>
                <div className="form-group">
                  <label className="checkbox-wrap">
                    <input type="checkbox" required defaultChecked />
                    <p>
                      <Translate
                        id="regCheckbox1"
                        defaultMessage="By signing up for our website, you confirm your acceptance of the "
                       />
                      <a className="each" href="/content/en/terms-movio/?country=es&service=buz2mobile" target="_blank">
                        <Translate id="terms-conditions" defaultMessage="Terms & Conditions" />
                      </a>
                      &nbsp;,&nbsp;&nbsp;
                      <a className="each" href="/content/en/privacy-movio/?country=es&service=buz2mobile" target="_blank">
                        <Translate id="privacy-policy" defaultMessage="Privacy Policy" />
                      </a>
                      &nbsp;,&nbsp;&nbsp;
                      <Translate
                        id="regCheckbox2"
                        defaultMessage="and voluntarily opt into our subscription service, ensuring you receive the full benefits of our platform"
                       />
                      .
                    </p>
                  </label>
                </div>
                <button
                  id="user-details-submit-button"
                  type="submit"
                  className="btn dcbp btn-red"
                  disabled={
                    (!email || !validEmail) ||
                    (!cc_holder || !validCcholder) ||
                    (!cc_number || !validCcnumber) ||
                    (!country || !validCountry) ||
                    (!cvv || !validCvv) ||
                    (!expirationMonths || !validExpirationMonths) ||
                    (!expirationYear || !validExpirationYear)
                  }
                >
                  <Translate id="finish" defaultMessage="finish" />
                </button>
              </div>
            </div>
            <div className="box find-wrap">
              <h4><Translate id="bestExp" defaultMessage="The Best Digital Experience" /></h4>
              <div className="container">
                <div>
                  <figure>
                    <img src={vod} />
                  </figure>
                </div>
              </div>
              <div className="container">
                <div className="each">
                  <h5>
                    <Translate id="regTerms-title-1" defaultMessage="Safe and Secure" />
                  </h5>
                  <p>
                    <Translate
                      id="regTerms-p-1"
                      defaultMessage="All user data are protected in the service.  Your information is safe and secure as we protect our member’s information by using the best security measures possible. We will not sell or rent your private information to third parties, we value your privacy."
                     />
                  </p>
                </div>
                <div className="each">
                  <h5>
                    <Translate
                      id="regTerms-title-2"
                      defaultMessage="Why do we need your billing information?"
                     />
                  </h5>
                  <p>
                    <Translate
                      id="regTerms-p-2"
                      defaultMessage="Because we are only licensed to distribute our content to certain countries, we ask that you verify your mailing address by providing us with a valid credit card number. No charges will appear on your credit card statement unless you upgrade to a Premium Membership or make a purchase."
                     />
                  </p>
                </div>
              </div>
            </div>
            <div className="box find-wrap">
              <div className="container">
                <div className="each">
                  <h5>
                    <Translate id="regTerms-title-4" defaultMessage="Get access now and start streaming" />
                  </h5>
                  <p>
                    <Translate
                      id="regTerms-p-3"
                      defaultMessage="We make sure to provide our members with a detailed transaction history so that they know what they are paying for. Credit card information is required to facilitate future purchases only."
                     />
                  </p>
                </div>
                <div className="each">
                  <h5>
                    <Translate id="regTerms-title-5" defaultMessage="Cancellation Policy" />
                  </h5>
                  <p>
                    <Translate
                      id="regTerms-p-5"
                      defaultMessage="You can cancel your membership at any time by contacting our Customer Care Department free of charge."
                     />
                  </p>
                </div>
              </div>
            </div>
            <div className="disclaimer box">
              <a className="each" href="/content/en/privacy-movio/?country=es&service=buz2mobile" target="_blank">
                <Translate id="privacy-policy" defaultMessage="Privacy Policy" />
              </a>
              <a className="each" href="/content/en/refund-policy-movio/?country=es&service=buz2mobile" target="_blank">
                <Translate id="refund-policy" defaultMessage="Refund Policy" />
              </a>
              <a className="each" href="/content/en/terms-movio/?country=es&service=buz2mobile" target="_blank">
                <Translate id="terms-conditions" defaultMessage="Terms & Conditions" />
              </a>
              <a className="each" href="/content/en/faq-movio/?country=es&service=buz2mobile" target="_blank">
                <Translate id="faq" defaultMessage="FAQ" />
              </a>
            </div>
          </section>
        )}

      </form>
    </div>
  );
};

export default injectIntl(UserDetailsEntryStep);
